const COMBINING_MARKS_PATTERN = /[\u0300-\u036f]/g;
const APOSTROPHE_PATTERN = /[\u2018\u2019\u201b\u2032'`´]/g;
const NON_WORD_SEPARATOR_PATTERN = /[^\p{L}\p{N}\s]/gu;
const SHORT_ANSWER_COMPACT_MAX_LENGTH = 30;

export function isShortAnswerMatch(
  userAnswer: string,
  expectedAnswer: string,
): boolean {
  const normalizedUserAnswer = normalizeShortAnswer(userAnswer);
  if (!normalizedUserAnswer) {
    return false;
  }

  const normalizedExpectedAnswer = normalizeShortAnswer(expectedAnswer);
  if (!normalizedExpectedAnswer) {
    return false;
  }

  if (normalizedUserAnswer === normalizedExpectedAnswer) {
    return true;
  }

  if (
    normalizedUserAnswer.length > SHORT_ANSWER_COMPACT_MAX_LENGTH ||
    normalizedExpectedAnswer.length > SHORT_ANSWER_COMPACT_MAX_LENGTH
  ) {
    return false;
  }

  return (
    compactShortAnswer(normalizedUserAnswer) ===
    compactShortAnswer(normalizedExpectedAnswer)
  );
}

export function normalizeShortAnswer(value: string): string {
  return value
    .normalize('NFD')
    .replace(COMBINING_MARKS_PATTERN, '')
    .toLowerCase()
    .replace(APOSTROPHE_PATTERN, '')
    .replace(NON_WORD_SEPARATOR_PATTERN, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function compactShortAnswer(value: string): string {
  return value.replace(/\s+/g, '');
}
